import { Action } from "@ngrx/store";
import { ActionModel } from "../model/action.model";
import { Sec002Model } from "../model/sec002.model";

export const sec002: any = new Sec002Model();

export function Sec002Reducer(state: Sec002Model = new Sec002Model(), action: Action) {    
    const actionModel = action as ActionModel; 

    switch (actionModel.type) {
        case 'ADD':
            {                          
                state.siloDestino = actionModel.payload;
                return state;
            };

        case 'REM':
            {                
                return state;
            };

        case 'CLE':
            {
                state = new Sec002Model;
                return state;
            }

        default:
            return state;
    }


}
